import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { RangeValueAccessor } from '@angular/forms';


// Menu
export interface Menu {
	headTitle1?: string,
	headTitle2?: string,
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	acceso?:string;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService implements OnDestroy {


	private unsubscriber: Subject<any> = new Subject();
	public  screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

	// Search Box
	public search: boolean = false;

	// Language
	public language: boolean = false;
	
	// Mega Menu
	public megaMenu: boolean = false;
	public levelMenu: boolean = false;
	public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

	// Collapse Sidebar
	public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

	// Full screen
	public fullScreen: boolean = false;

	constructor(private router: Router) {

		this.setScreenWidth(window.innerWidth);
		fromEvent(window, 'resize').pipe(
			debounceTime(1000),
			takeUntil(this.unsubscriber)
		).subscribe((evt: any) => {
			this.setScreenWidth(evt.target.innerWidth);
			if (evt.target.innerWidth < 991) {
				this.collapseSidebar = true;
				this.megaMenu = false;
				this.levelMenu = false;
			}
			if(evt.target.innerWidth < 1199) {
				this.megaMenuColapse = true;
			}
		});
		if(window.innerWidth < 991) { // Detect Route change sidebar close
			this.router.events.subscribe(event => { 
				this.collapseSidebar = true;
				this.megaMenu = false;
				this.levelMenu = false;
			});
		}
	}

	ngOnDestroy() {
		this.unsubscriber.next();
		this.unsubscriber.complete();
	}

	private setScreenWidth(width: number): void {
		this.screenWidth.next(width);
	}

	MENUITEMS: Menu[] = [
		{
			path: '/dashboard/resumen', title: 'Resumen del Sistema', icon: 'airplay', type: 'link', acceso:'resumen'
		},
		{
			headTitle1: 'Kardex', headTitle2: 'llenado de hojas de vida del personal', acceso:'kardex'
		},
		{
			title: 'File Personal', icon: 'folder', type: 'sub', badgeType: 'success', active: true,acceso:'hojavida', children: [
				{ path: '/kardex/listado', title: 'Listado de CV',acceso:'listhojavida', type: 'link' },
				{ path: '/kardex/registro/*/*', title: 'Mi hoja de vida',acceso:'dethojavida', type: 'link' },
				{ path: '/kardex/decjurada', title: 'Form. Incompatibilidad',acceso:'decjurada', type: 'link' },
				{ path: '/kardex/decDoblePercepcion', title: 'Form. Doble Percepción',acceso:'decjurada', type: 'link' },
				{ path: '/kardex/decVeracidadDocumentos', title: 'Form. Veracidad de Documentos',acceso:'decjurada', type: 'link' },
				{ path: '/kardex/datosuser', title: 'Información Personal',acceso:'infouser', type: 'link' }
			]
		},

		{
			headTitle1: 'Permisos y Vacaciones', headTitle2: 'Solicitud de Boletas de Permisos y Vacaciones',acceso:'boletas'
		},
		{
			title: 'Permisos y Vacaciones', icon: 'file-text', type: 'sub', badgeType: 'success', active: false,acceso:'formsolicitud', children: [
				{ path: '/personal/permisos', title: 'Permisos y Licencias',acceso:'c_permiso', type: 'link' },
				{ path: '/personal/vacaciones', title: 'Formulario de Vacación',acceso:'c_formvac', type: 'link' },
				{ path: '/personal/detboletas', title: 'Registro de Permisos',acceso:'c_detpermiso', type: 'link' },
				{ path: '/personal/detvacaciones', title: 'Registro de Vacación',acceso:'c_detvacacion', type: 'link' },
				{ path: '/personal/marcaciones', title: 'Reporte de Asistencia',acceso:'c_marcacion', type: 'link' }
			]
		},

		{
			headTitle1: 'Recursos Humanos', headTitle2: 'Registro y administración de Personal',acceso:'personal'
		},
		{
			title: 'Registro de personal', icon: 'users', type: 'sub', badgeType: 'success', active: false,acceso:'asignacionrrhh', children: [
				{ path: '/personal/escala', title: 'Escala y Perfil Ref.',acceso:'escala', type: 'link' },
				{ path: '/personal/items', title: 'Administración de Items',acceso:'item', type: 'link' },
				{ path: '/personal/permanente', title: 'Personal Permanente',acceso:'permanente', type: 'link' },
				{ path: '/personal/eventual', title: 'Personal Eventual',acceso:'eventual', type: 'link' },
				{ path: '/personal/externo', title: 'Personal Externo',acceso:'externo', type: 'link' },
				{ path: '/personal/repPersonal', title: 'Reporte General',acceso:'reppersonal', type: 'link' }
			]
		},

		{
			headTitle1: 'Planilla de Personal', headTitle2: 'Generación de Planillas mensuales del Personal',acceso:'planilla'
		},
		{
			title: 'Sueldos y Salarios', icon: 'dollar-sign', type: 'sub', badgeType: 'success', active: false,acceso:'p_planilla', children: [
				{ path: '/planilla/refrigerio', title: 'Planilla de refrigerio',acceso:'p_refrigerios', type: 'link' },
				{ path: '/planilla/salarios', title: 'Planilla de sueldos',acceso:'p_sueldos', type: 'link' }
			]
		},

		// {
		// 	headTitle1: 'Almacenes', headTitle2: 'Solicitud e ingreso de material',acceso:'almacen'
		// },
		// {
		// 	title: 'Registro de Material', icon: 'repeat', type: 'sub', badgeType: 'success', active: false,acceso:'a_config', children: [
		// 		{ path: '/almacen/solicitud', title: 'Solicitud de material',acceso:'a_solicitud', type: 'link' },
		// 		{ path: '/almacen/ingresos', title: 'Ingresos de material',acceso:'a_ingresos', type: 'link' },
		// 		{ path: '/almacen/saldos', title: 'Stock e inventario',acceso:'a_saldos', type: 'link' },
		// 		{ path: '/almacen/proveedor', title: 'Proveedores',acceso:'a_proveedor', type: 'link' },
		// 		{ path: '/almacen/categoria', title: 'Almacen y partidas',acceso:'a_partidas', type: 'link' },
		// 		{ path: '/almacen/materiales', title: 'Materiales',acceso:'a_material', type: 'link' },
		// 		{ path: '/almacen/reporte', title: 'Reportes',acceso:'a_reportes', type: 'link' }
		// 	]
		// },

		
	];


	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

}

